/**
 * A banner over the canvas (ADR 0005), drawn as the retro kit's `center`
 * panel since slice 6b: floor entered and cleared,
 * the boss defeated, an egg obtained, the run completed, failed or escaped.
 * Text from `ui.banner.*` keys; it holds for `uiTiming.banner` (the shell
 * removes it, and queues banners that come together so each holds at least
 * `uiTiming.bannerMinHold`).
 */
import type { Strings } from '@ab/session';
import { Panel } from './panel.tsx';
import { type TextArgs, formatText } from './text.ts';
import './overlays.css';

export type BannerRequest = TextArgs & { readonly id: number; readonly key: string; readonly tone: 'plain' | 'warn'; readonly durationMs: number };

export const Banner = ({ banner, strings }: { readonly banner: BannerRequest | null; readonly strings: Strings }) =>
  banner === null ? null : (
    <Panel key={banner.id} placement="center" className={`ab-banner ab-banner-${banner.tone}`} data-testid="banner" data-id={banner.id} role="status" style={{ animationDuration: `${banner.durationMs}ms` }}>
      {formatText(strings, banner.key, banner)}
    </Panel>
  );
